import 'url-search-params-polyfill';

import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import Scroll from './components/ScrollToTop';
import PageContent from './PageContent';
import { Store } from './store';
import { QueryClientProvider } from '@tanstack/react-query';
import { GoogleOAuthProvider } from '@react-oauth/google';
import ConsentBanner from './components/consent/ConsentBanner';
import { HelmetProvider } from 'react-helmet-async';
import invariant from './lib/invariant';
import { ExperimentContext } from './hooks/useExperiment';
import { TeamModeProvider } from './hooks/useTeamMode';
import { queryClient } from './queryClient';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export default function Root({ store }: { store: Store }) {
  invariant(GOOGLE_CLIENT_ID, 'Missing Google Client ID');
  const { userId } = store.getState().user;
  const experimentContext = {
    userId,
    useExperimentServerSide: () => 'control' as const, // unused
  };

  return (
    <HelmetProvider>
      <ExperimentContext.Provider value={experimentContext}>
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <QueryClientProvider client={queryClient}>
            <Provider store={store}>
              <Router>
                <TeamModeProvider>
                  <Scroll>
                    <PageContent />
                  </Scroll>
                  <ConsentBanner />
                </TeamModeProvider>
              </Router>
            </Provider>
          </QueryClientProvider>
        </GoogleOAuthProvider>
      </ExperimentContext.Provider>
    </HelmetProvider>
  );
}
